<script>
  import { createEventDispatcher } from 'svelte';
  import { clientStore } from '../../stores/client';

  export let client = null;

  const dispatch = createEventDispatcher();

  let formData = {
    name: client?.name || '',
    contact_email: client?.contact_email || '',
    phone_number: client?.phone_number || '',
    notes: client?.notes || ''
  };

  let loading = false;
  let error = '';

  function formatPhone(v) {
    const d = v.replace(/\D/g, '');
    if (d.length <= 3) return d;
    if (d.length <= 6) return `(${d.slice(0,3)}) ${d.slice(3)}`;
    return `(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6,10)}`;
  }

  async function handleSubmit() {
    if (!formData.name.trim()) {
      error = 'Name is required';
      return;
    }

    loading = true;
    error = '';

    try {
      const data = {
        name: formData.name.trim(),
        contact_email: formData.contact_email.trim() || null,
        phone_number: formData.phone_number.replace(/\D/g, '') || null,
        notes: formData.notes.trim() || null
      };

      if (client?.id) {
        await clientStore.update(client.id, data);
      } else {
        await clientStore.add(data);
      }
      dispatch('close');
    } catch (e) {
      error = e.message || 'Failed to save';
    } finally {
      loading = false;
    }
  }
</script>

<div class="form-container">
  <div class="form-header">
    <h2>{client ? 'Edit Client' : 'New Client'}</h2>
    <button class="btn btn-secondary" on:click={() => dispatch('close')}>Cancel</button>
  </div>

  {#if error}
    <div class="form-error">{error}</div>
  {/if}

  <form on:submit|preventDefault={handleSubmit}>
    <div class="form-group">
      <label for="name">Name <span class="required">*</span></label>
      <input id="name" type="text" bind:value={formData.name} placeholder="Client name" required />
    </div>

    <div class="form-group">
      <label for="email">Email</label>
      <input id="email" type="email" bind:value={formData.contact_email} placeholder="email@example.com" />
    </div>

    <div class="form-group">
      <label for="phone">Phone</label>
      <input id="phone" type="tel" value={formData.phone_number} on:input={e => formData.phone_number = formatPhone(e.target.value)} placeholder="(555) 555-5555" />
    </div>

    <div class="form-group">
      <label for="notes">Notes</label>
      <textarea id="notes" bind:value={formData.notes} rows="3" placeholder="Additional notes..."></textarea>
    </div>

    <div class="form-actions">
      <button type="submit" class="btn btn-primary" disabled={loading}>
        {loading ? 'Saving...' : 'Save Client'}
      </button>
    </div>
  </form>
</div>

<style>
  .form-container {
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    overflow: hidden;
  }

  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid var(--border);
  }

  .form-header h2 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }

  .form-error {
    margin: 16px 20px 0;
    padding: 12px;
    background: #fee2e2;
    color: #dc2626;
    border-radius: var(--radius);
    font-size: 13px;
  }

  form {
    padding: 20px;
  }

  .form-group {
    margin-bottom: 16px;
  }

  label {
    display: block;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 6px;
    color: var(--text);
  }

  .required {
    color: var(--danger);
  }

  input, textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    font-size: 14px;
    background: #fff;
  }

  input:focus, textarea:focus {
    outline: none;
    border-color: var(--accent);
  }

  textarea {
    resize: vertical;
    min-height: 80px;
  }

  .form-actions {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
</style>
